import { Accordion, typographyV2, values } from '@toggle/design-system';
import styled from 'styled-components';

export const StyledAccordion = styled(Accordion)`
  ${Accordion.Styled.AccordionItem} {
    background-color: unset;
    border-bottom-left-radius: ${values.r2};
    border-bottom-right-radius: ${values.r2};
    border: 1px solid var(--border-soft);
    margin-bottom: 12px;
    overflow: hidden;

    &:hover {
      background-color: unset;
    }
  }

  ${Accordion.Styled.TitleContainer} {
    padding: 6px 8px;
    color: var(--text-default);
    border: none;
    ${typographyV2.bodySm};
    background-color: var(--surface-default);
  }

  ${Accordion.Styled.Content} {
    padding: 0;
  }

  ${Accordion.Styled.IconStyled} {
    width: 12px;
    height: 12px;
    fill: var(--icon-default);
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  gap: 0.35em;
`;

export const TitleLabel = styled.span`
  color: var(--text-default);
`;

export const CountLabel = styled.span`
  color: var(--text-soft);
`;

export const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ItemContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:not(:last-child) {
    border-bottom: 1px solid var(--border-soft);
  }

  &:hover {
    background: var(--surface-hover);
  }
`;

export const StyledFavicon = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 8px;
  vertical-align: middle;
  flex-shrink: 0;
`;

export const ItemContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  overflow: hidden;
`;

export const CitationTitle = styled.span`
  ${typographyV2.bodySm};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const CitationUrl = styled.span`
  ${typographyV2.bodyXs};
  color: var(--text-soft);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
